import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import MarqueeRibbon from "./components/MarqueeRibbon";
import Especialidades from "./components/Especialidades";
import AntesDepois from "./components/AntesDepois";
import Urgencias from "./components/Urgencias";
import FormularioMarcacao from "./components/FormularioMarcacao";
import Clinica from "./components/Clinica";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Header />
      <main>
        <Hero />
        <MarqueeRibbon />
        <Especialidades />
        <AntesDepois />
        <Urgencias />
        <FormularioMarcacao />
        <Clinica />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/especialidades" element={<HomePage />} />
          <Route path="/urgencias" element={<HomePage />} />
          <Route path="/contactos" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
